import React, { useState, useEffect } from "react";
import "../../../components/Styles/FormStyle.css";
import "../../../components/Styles/SecondPage.css";
import { secret } from "../data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const Choosen = (props) => {
  const getData = () => {};

  useEffect(() => {
    console.log(props.choosen.split(",").filter((eq) => eq !== "").length);
  }, [props.choosen]);

  const getChoosen = () => {
    return choosenH;
  };

  const getChoosenM = () => {
    return choosenHM;
  };

  const choosenH =
    props.choosen.split(",").filter((eq) => eq !== "").length > 0
      ? props.choosen
          .split(",")
          .filter((eq) => eq !== "")
          .map((ep) => (
            <div
              style={{
                display: "flex",
                fontSize: "1vw",
                alignItems: "center",
                marginBottom: "10px",
                minHeight: "3vh",
                gap: "10px",
              }}
            >
              <div style={{ width: "70%" }}>
                {props.companyData
                  .filter((eq) => +eq.id === +ep)[0]
                  .name.replaceAll("<br>", "")
                  .replaceAll("<BR>", "")}
              </div>
              <div style={{ width: "30%" }}>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    margin: "0",
                    fontSize: ".9vw",
                    height: "2vh",
                    color: "white",
                    backgroundColor: "#949d97",
                    border: "0px solid #949d97",
                    borderRadius: "10px",
                    minWidth: "8vw",
                    fontWeight: "600",
                  }}
                  value={ep}
                  onClick={props.deleteChoosen}
                >
                  usuń
                </button>
              </div>
            </div>
          ))
      : "";

  const choosenHM =
    props.choosen.split(",").filter((eq) => eq !== "").length > 0
      ? props.choosen
          .split(",")
          .filter((eq) => eq !== "")
          .map((ep) => (
            <div
              style={{
                display: "flex",
                fontSize: "3vw",
                alignItems: "center",
                marginBottom: "10px",
                minHeight: "3vh",
                gap: "10px",
              }}
            >
              <div style={{ width: "70%" }}>
                {props.companyData
                  .filter((eq) => +eq.id === +ep)[0]
                  .name.replaceAll("<br>", "")
                  .replaceAll("<BR>", "")}
              </div>
              <div style={{ width: "30%" }}>
                <button
                  className="submitButtonFirstPage"
                  style={{
                    margin: "0",
                    fontSize: "2vw",
                    height: "2vh",
                    color: "white",
                    backgroundColor: "#949d97",
                    border: "0px solid #949d97",
                    borderRadius: "10px",
                    minWidth: "8vw",
                    fontWeight: "600",
                    padding: "5px",
                  }}
                  value={ep}
                  onClick={props.deleteChoosen}
                >
                  usuń
                </button>
              </div>
            </div>
          ))
      : "";

  const destkop = (
    <>
      <div
        className="progressBox"
        style={{
          width: "30vw",
          border: "1px solid rgba(0, 0, 0, 0.322)",
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
          padding: "15px 15px",
          backgroundColor: "white",
          position: "fixed",
          left: "0",
          zIndex: "2",
          bottom: "0",
          boxShadow: "-2px -2px 29px 0px rgba(66, 68, 90, 1)",
          paddingLeft: "15px",
        }}
      >
        <p
          style={{
            fontSize: "1vw",
            textTransform: "uppercase",
            marginBottom: "3vh",
          }}
        >
          <span style={{ fontWeight: "900", fontSize: "1vw" }}>
            KONTAKT Z KANCELARIAMI
          </span>
          <br />
          <br />
          Wybierz maksymalnie 5 kancelarii prawnych, które odpowiadają Twoim
          oczekiwaniom. Wybrane kancelarie skontaktują się z Tobą, aby
          przedstawić ofertę na usługi prawne w zakresie odzyskania nadpłaconych
          rat z tytułu spłaty zobowiązania.
        </p>
        {getChoosen()}
        <div
          style={{ display: "flex", justifyContent: "right", marginTop: "3vh" }}
        >
          <button
            className="submitButtonFirstPage"
            style={{
              margin: "0",
              fontSize: ".9vw",
              color: "white",
              height: "3vh",
              backgroundColor: "#949d97",
              border: "0px solid #949d97",
              borderRadius: "10px",
              minWidth: "8vw",
              padding: "5px 10px",
              fontWeight: "900",
            }}
            onClick={props.sendAssingments}
          >
            wyślij zapytanie do kancelarii
          </button>
        </div>
      </div>
    </>
  );
  const mobile = (
    <>
      <div
        className="progressBox"
        style={{
          width: "75vw",
          border: "1px solid rgba(0, 0, 0, 0.322)",
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
          padding: "15px 15px",
          backgroundColor: "white",
          position: "fixed",
          left: "0",
          zIndex: "2",
          bottom: "0",
          boxShadow: "-2px -2px 29px 0px rgba(66, 68, 90, 1)",
          paddingLeft: "15px",
        }}
      >
        <p
          style={{
            fontSize: "3vw",
            textTransform: "uppercase",
            marginBottom: "3vh",
          }}
        >
          <span style={{ fontWeight: "900", fontSize: "3vw" }}>
            KONTAKT Z KANCELARIAMI
          </span>
          <br />
          <br />
          <span style={{ fontSize: "2vw" }}>
            Wybierz maksymalnie 5 kancelarii prawnych, wybrane kancelarie
            skontaktują się z Tobą, aby przedstawić ofertę.
          </span>
        </p>

        {getChoosenM()}
        <div
          style={{ display: "flex", justifyContent: "right", marginTop: "3vh" }}
        >
          <button
            className="submitButtonFirstPage"
            style={{
              margin: "0",
              fontSize: "3vw",
              color: "white",
              height: "3vh",
              backgroundColor: "#949d97",
              border: "0px solid #949d97",
              borderRadius: "10px",
              minWidth: "8vw",
              padding: "5px 10px",
              fontWeight: "900",
            }}
            onClick={props.sendAssingments}
          >
            wyślij zapytanie do kancelarii
          </button>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="destkopView">{destkop}</div>
      <div className="mobileView">{mobile}</div>
    </>
  );
};

export default Choosen;
